import { Content, Page } from '@backstage/core-components';
import {
  HomePageCompanyLogo,
  HomePageRecentlyVisited,
  HomePageStarredEntities,
  HomePageToolkit,
  HomePageTopVisited,
  Tool,
} from '@backstage/plugin-home';
import { HomePageSearchBar } from '@backstage/plugin-search';
import { SearchContextProvider } from '@backstage/plugin-search-react';
import { Grid, makeStyles, useTheme } from '@material-ui/core';
import CloudIcon from '@material-ui/icons/Cloud';
import ComputerIcon from '@material-ui/icons/Computer';
import FlagIcon from '@material-ui/icons/Flag';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import TouchAppIcon from '@material-ui/icons/TouchApp';

import { DxIcon } from '@internal/backstage-plugin-dx-setup';

import { IsolvedLogoFullDark } from '../../icons/IsolvedLogoFullDark';
import { IsolvedLogoFullLight } from '../../icons/IsolvedLogoFullLight';
import { CLOUDOPS_INTAKE_URL } from '../../util/links';

const tools: Tool[] = [
  {
    label: 'isolved Wiki',
    url: '/docs/default/component/isolved-wiki',
    icon: <MenuBookIcon />,
  },
  {
    label: 'isolved Feature Flags',
    url: '/catalog/default/component/isolved-feature-flags',
    icon: <FlagIcon />,
  },
  {
    label: 'CloudOps Intake',
    url: CLOUDOPS_INTAKE_URL,
    icon: <CloudIcon />,
  },
  {
    label: 'Workstation Setup',
    url: '/workstation-setup',
    icon: <ComputerIcon />,
  },
  {
    label: 'Dx Setup',
    url: '/dx-setup',
    icon: <DxIcon />,
  },
  {
    label: 'Prototypes',
    url: '/prototypes',
    icon: <TouchAppIcon />,
  },
];

const useStyles = makeStyles(theme => ({
  svg: {
    width: 'auto',
    height: 100,
  },
  container: {
    margin: theme.spacing(5, 0),
  },
  searchBarInput: {
    maxWidth: '60vw',
    margin: 'auto',
    backgroundColor: theme.palette.background.paper,
    borderRadius: '50px',
    boxShadow: theme.shadows[1],
  },
  searchBarOutline: {
    borderStyle: 'none',
  },
}));

export const HomePage = () => {
  const classes = useStyles();
  const theme = useTheme();

  const logo =
    theme.palette.type === 'dark' ? (
      <IsolvedLogoFullDark classes={{ svg: classes.svg }} />
    ) : (
      <IsolvedLogoFullLight classes={{ svg: classes.svg }} />
    );

  return (
    <SearchContextProvider>
      <Page themeId="home">
        <Content>
          <Grid container justifyContent="center" spacing={2}>
            <HomePageCompanyLogo className={classes.container} logo={logo} />
            <Grid container item xs={12} justifyContent="center">
              <HomePageSearchBar
                InputProps={{
                  classes: {
                    root: classes.searchBarInput,
                    notchedOutline: classes.searchBarOutline,
                  },
                }}
                placeholder="Search"
              />
            </Grid>
            <Grid container item xs={12}>
              <Grid item xs={12} md={6}>
                <HomePageTopVisited />
              </Grid>
              <Grid item xs={12} md={6}>
                <HomePageRecentlyVisited />
              </Grid>
            </Grid>
            <Grid container item xs={12}>
              <Grid item xs={12} md={6}>
                <HomePageStarredEntities groupByKind />
              </Grid>
              <Grid item xs={12} md={6}>
                <HomePageToolkit tools={tools} />
              </Grid>
            </Grid>
          </Grid>
        </Content>
      </Page>
    </SearchContextProvider>
  );
};
